import { Loader2 } from "lucide-react";
import { JOURNAL_LANGS } from "../lib/journalI18n";

export const LangSwitcher = ({ lang, setLang, translating = false, small = false }) => (
  <div className="flex items-center gap-1.5 shrink-0">
    {translating && <Loader2 className="w-4 h-4 animate-spin text-muted-foreground" data-testid="journal-translating" />}
    <div className="flex items-center gap-0.5 bg-secondary/70 rounded-full p-1" data-testid="journal-lang-switcher">
      {JOURNAL_LANGS.map((l) => (
        <button key={l.code} type="button" data-testid={`journal-lang-${l.code}`} onClick={() => setLang(l.code)} title={l.label}
          className={`${small ? "w-7 h-7 text-sm" : "w-8 h-8 text-base"} rounded-full leading-none flex items-center justify-center transition-[background-color,opacity,transform] duration-200 ${lang === l.code ? "bg-card shadow scale-105" : "opacity-55 hover:opacity-100"}`}>
          {l.flag}
        </button>
      ))}
    </div>
  </div>
);
